import React, {useEffect} from "react";
import Popup from "../../generic/Popup";
import { useInjection } from 'brandi-react';
import { observer } from 'mobx-react-lite';
import './style.scss';
import i18next from "i18next";
import {Button, Input, Label, Row} from "reactstrap";
import Logo from "../../layout/ Logo";
import emailTick from "../../../styles/assets/images/sv/email-tick.svg";
import {useForm} from "react-hook-form";
import TwfaModal from "../../profile/ProfileData/TwfaModal";
import {usePublicEndpoints} from "../../../lib/api/usePublicEndpoints";
import {AddEmailPopupModelToken} from "./model/index.model";

const AddEmailPopup = () => {
    const { t } = i18next;
    const {updateClientPersonal} = usePublicEndpoints();
    const addEmailPopupModel = useInjection(AddEmailPopupModelToken);
    const { register, errors, handleSubmit, getValues } = useForm({
        mode: "onChange",
        reValidateMode: "onChange"
    });
    const values = getValues();

    const onSubmit = (data) => {
        addEmailPopupModel.handleEmailSubmit(data)
    }

    const handleUpdateUser = (code) => {
        addEmailPopupModel.handleUpdate(
            {...addEmailPopupModel.presaveValues, code},
            updateClientPersonal
        );
    }

    useEffect(() => {
        if (addEmailPopupModel.isFillingEmailPopupShown) {
            addEmailPopupModel.setIsModalEmailOpen(addEmailPopupModel.isFillingEmailPopupShown);
        }
    }, [addEmailPopupModel.isFillingEmailPopupShown]);

    if (!addEmailPopupModel.isModalEmailOpen) {
        return null;
    }
    return (
        <Popup isOpen={addEmailPopupModel.isModalEmailOpen} withoutButtons={true} toggle={addEmailPopupModel.closeAddEmailPopup}>
            <div id={'login'}>
                <div className={'login-container'}>
                    <Logo />
                    <div className="login-sub-logo login-text">
                        {t('common.fillingEmail')}
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} action="">
                        <Row className="no-gutters login-row">
                            <img alt="" src={emailTick} className={values.email && !errors.email ? "email-correct" : "email-correct d-none"} />
                            <Label htmlFor="email" className="login-label">
                                {t('common.fields.email.label')}
                            </Label>
                            <Input
                                className={!!errors.email ? "login-input has-error" : "login-input"}
                                type="text"
                                id="email"
                                name="email"
                                innerRef={register({
                                    required: true,
                                    pattern: /^\S+@\S+\.\S+$/
                                })}
                            />
                            <span className={"error-label w-100"}>
                    {errors.email?.type === "required" ? t('common.fields.email.validation.required') : ""}
                                {errors.email?.type === "pattern" ? t('common.fields.email.validation.pattern') : ""}
                    </span>
                        </Row>
                        <Row className={'no-gutters'}>
                            <Button type="submit" className={'w-100 reg-button'} color={'primary'}>
                                {t('common.buttons.saveEmail')}
                            </Button>
                        </Row>
                    </form>
                </div>
            </div>
            {addEmailPopupModel.isModalOpen && <TwfaModal
                toggle={() => addEmailPopupModel.setIsModalOpen(false)}
                customHandler={handleUpdateUser}
                email={addEmailPopupModel.email}
            />}
        </Popup>
    )
}

export default observer(AddEmailPopup);